import script from "./OnlineCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineCard.vue?vue&type=script&setup=true&lang=js"

import "./OnlineCard.vue?vue&type=style&index=0&id=7a5a52a2&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5a52a2"]])

export default __exports__